import React, { useState } from 'react';
import { CgClose } from "react-icons/cg";
import { toast } from 'react-toastify';
import Switch from "react-switch";
import SummaryApi from '../common';

const UploadBrand = ({
  onClose,
  fetchdata
}) => {

  const [data, setData] = useState({
    brandname: "",
    isactive: true,
  });

  const [loading, setLoading] = useState(false);

  // Handle input change
  const handleOnChange = (e) => {
    const { name, value } = e.target;

    setData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle active switch
  const handleActiveToggle = (checked) => {
    setData((prev) => ({
      ...prev,
      isactive: checked
    }));
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const formData = new FormData();

      formData.append("brandname", data.brandname);
      formData.append("isactive", data.isactive ? 1 : 0);

      const response = await fetch(
        SummaryApi.uploadBrand.url,
        {
          method: SummaryApi.uploadBrand.method,
          headers: {
            Authorization: "Bearer oakyaecom_no_units_916",
          },
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to upload Brand");
      }

      const responseData = await response.json();

      if (responseData.status) {
        toast.success(responseData.message);

        setData({
          brandname: "",
          isactive: true,
        });

        onClose();
        fetchdata();
      } else {
        toast.error(responseData.message);
      }

    } catch (error) {
      console.error(error);
      toast.error("Error uploading brand");

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='fixed w-full h-full bg-slate-200 bg-opacity-35 top-0 left-0 right-0 bottom-0 flex justify-center items-center z-50'>

      <div className='bg-white p-4 rounded w-full max-w-2xl relative shadow-lg'>

        {/* Header */}
        <div className='flex justify-between items-center pb-3 border-b'>
          <h2 className='font-bold text-lg'>
            Upload Brand
          </h2>

          <div
            className='text-2xl hover:text-red-600 cursor-pointer'
            onClick={onClose}
          >
            <CgClose />
          </div>
        </div>

        {/* Form */}
        <form
          className='grid gap-4 p-4'
          onSubmit={handleSubmit}
        >

          {/* Brand Name */}
          <div>
            <label className='block mb-2 font-medium'>
              Brand Name
            </label>

            <input
              required
              type='text'
              name='brandname'
              value={data.brandname}
              onChange={handleOnChange}
              placeholder='Enter brand name'
              className='w-full p-2 h-10 bg-slate-100 border rounded focus:outline-none focus:border-red-500'
            />
          </div>

          {/* Active Switch */}
          <div>
            <label className='block mb-2 font-medium'>
              Status
            </label>

            <Switch
              onChange={handleActiveToggle}
              checked={data.isactive}
              height={24}
              width={78}
              handleDiameter={20}
              handleStyle={{
                backgroundColor: "#4caf50",
                boxShadow: "0 0 2px 3px rgba(0,0,0,0.1)"
              }}
              onColor="#008000"
              offColor="#D22B2B"
              checkedIcon={
                <div className='flex justify-center items-center h-full text-sm ml-3 text-white'>
                  Active
                </div>
              }
              uncheckedIcon={
                <div className='flex justify-center items-center h-full text-[11px] mr-4 text-white'>
                  InActive
                </div>
              }
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className='px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50'
          >
            {loading ? "Uploading..." : "Upload Brand"}
          </button>

        </form>

        {/* Loader Overlay */}
        {loading && (
          <div className='absolute top-0 left-0 right-0 bottom-0 bg-white bg-opacity-70 flex justify-center items-center rounded'>
            <div className='text-lg font-bold'>
              Uploading Brand...
            </div>
          </div>
        )}

      </div>

    </div>
  );
};

export default UploadBrand;